import * as dates from '@simplybenefits/sb-dates';

/**
 * @param date
 * @param format
 * @returns {*}
 */
function formatDateForDisplay(date, format = 'll') {
  return dates.getUTC(date, format);
}

/**
 * Date will be coming in as unix time / 1000
 * @param date
 * @returns {*}
 */
function formatIncomingDate(date) {
  return dates.getUTC(date, "YYYY/MM/DD");
}

/**
 * Convert the provided date to the start of that day (12AM) - This is only used for Birth dates, Hire Dates etc.. where time is not included. We set the in value to a truthy value (1) so as not to create any issues when a value of 0, (01/01/1970) is passed.
 * @param date
 * @returns {*}
 */
function formatOutgoingDate(date) {
  let ready = dates.getStartOfDay(date);
  if (ready === 0) {
    ready = 1;
  }
  return ready;
}

/**
 * @param date
 * @param noFuture
 * @param noPast
 * @param mustBeFirstOfMonth
 */
function validateDate(date, noFuture = true, noPast = false, mustBeFirstOfMonth = false, locale = "en") {
  return dates.validate(date, noFuture, noPast, mustBeFirstOfMonth, locale);
}
export { formatDateForDisplay, formatIncomingDate, formatOutgoingDate, validateDate };